import { render } from "./AddPrimaryStorage.vue?vue&type=template&id=7070878b&scoped=true"
import script from "./AddPrimaryStorage.vue?vue&type=script&lang=js"
export * from "./AddPrimaryStorage.vue?vue&type=script&lang=js"

import "./AddPrimaryStorage.vue?vue&type=style&index=0&id=7070878b&lang=scss&scoped=true"

import exportComponent from "/build/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7070878b"]])

export default __exports__